import * as $ from 'jquery';
import * as Cookies from 'js-cookie';
var CookieNotice = (function () {
    function CookieNotice(element, options) {
        this.options = {
            containerSelector: 'html',
            containerClass: 'has-cookie-notification',
            buttonSelector: 'button',
            cookieName: 'cookie-consent'
        };
        this.options = $.extend({}, this.options, options);
        this.$element = $(element);
        this.$container = $(this.options.containerSelector);
        this.setListeners();
    }
    CookieNotice.prototype.setListeners = function () {
        var _this = this;
        this.$element.on('click', this.options.buttonSelector, function (event) {
            _this.acceptCookieBanner();
            event.preventDefault();
        });
    };
    CookieNotice.prototype.acceptCookieBanner = function () {
        Cookies.set(this.options.cookieName, 1, { expires: 365, path: '/' });
        this.$container.removeClass(this.options.containerClass);
    };
    CookieNotice.prototype.showCookieBanner = function () {
        var cookieVal = Cookies.get(this.options.cookieName);
        var cookieSeen = (typeof cookieVal === 'undefined') ? false : cookieVal;
        if (!cookieSeen) {
            this.$container.addClass(this.options.containerClass);
        }
    };
    return CookieNotice;
}());
export { CookieNotice };
//# sourceMappingURL=cookienotice.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@pixelart/jquery-cookie-consent/dist/cookienotice.js
// module id = 40
// module chunks = 0